import React, { useEffect, useRef, useState } from 'react'
import { Image } from '@sitecore-jss/sitecore-jss-react'
import '../../styles/@shared/rte.scss'
import { useLocation, useNavigate } from 'react-router-dom';
import { LangModel } from './models/Lang.model'
import { getCookieValue, getExpiryDate } from '../../utils/window.utils'
import '../../styles/@shared/rte.scss'
import { ComponentProps } from '../../types/types';
import withRouter from '../@shared/withRouter';

interface LangProps extends ComponentProps { }

const LanguageSelector = (props) => {
  const model = new LangModel(props)

  const [langs, setLangs] = useState([])
  const [langChange, setLangChange] = useState(false)

  const location = useLocation();
  const navigate = useNavigate();

  const tooltipRef = useRef<HTMLDivElement>(null);
  const tooltipShown = useRef(false);
  const langRef = useRef<HTMLDivElement>(null);

  const changeLang = (currentLang) => {
    setLangChange(!langChange)
    const currentPath = location?.pathname
    const prevLang = getCookieValue('cnhicorporate#lang2')

    if (typeof document!== 'undefined') {
      if (currentLang) {
        document.cookie =
          'cnhicorporate#lang2=' + currentLang + ';path=/;' + getExpiryDate(10)
      } else {
        document.cookie = 'cnhicorporate#lang2=en;path=/;' + getExpiryDate(10)
      }
    }
    

    navigate(currentPath);
    //    {
    //   params: { forceReload: prevLang != currentLang ? true : false },
    // })

    // to rerender the icons
  }

  const elementInViewport = () => {
    if (tooltipRef?.current && !tooltipShown.current && (typeof window !== 'undefined')) {
      var bounding: DOMRect | undefined = tooltipRef?.current?.getBoundingClientRect()

      if (
        bounding.top >= 0 &&
        bounding.left >= 0 &&
        bounding.right <=
        (window.innerWidth || document.documentElement.clientWidth) &&
        bounding.bottom <=
        (window.innerHeight || document.documentElement.clientHeight)
      ) {
        tooltipRef.current.style.display = 'block'
        bounding = langRef?.current?.getBoundingClientRect()
        tooltipRef.current.style.left = '-' + (bounding?.width ?? 0) * 5 + 'px'
        setTimeout(() => {
          if (tooltipRef?.current) {
            tooltipRef.current.style.display = 'none'
            tooltipShown.current = true
          }
        }, 2000)
      } else {
        console.log('Element is NOT in the viewport!')
      }
    }
  }

  useEffect(() => {
    window && window.addEventListener('scroll', elementInViewport)

    return () => {
      window && window.removeEventListener('scroll', elementInViewport)
    }
  })

  const showLang = (lang) => {
    if (!getCookieValue('cnhicorporate#lang2') && lang == 'en') {
      return true
    }
    if (lang == getCookieValue('cnhicorporate#lang2')) {
      return true
    }

    return false
  }
  useEffect(() => {
    const allLangs = props?.fields?.Languages
    const langSelector = allLangs?.map((langs) => {
      const image = langs?.fields['Image Icon']?.value?.src
      const lang = langs?.fields['Short Language']?.value

      return (
        <Image
          style={{ display: showLang(lang) ? 'none' : 'block' }}
          key={lang}
          field={langs?.fields['Image Icon']}
          className="lang-image"
          onClick={() => {
            changeLang(lang)
          }}
        ></Image>
      )
    })

    setLangs(langSelector)
  }, [langChange])

  useEffect(() => {
    let timerHide, timerShow
    if (tooltipRef?.current) {
      timerHide = setTimeout(() => {
        if (tooltipRef.current) {
          tooltipRef.current.style.display = 'block'
          var bounding = langRef?.current?.getBoundingClientRect()
          tooltipRef.current.style.left = '-' + (bounding?.width ?? 0) * 5 + 'px'
        }
      }, 1000)
      timerShow = setTimeout(() => {
        if (tooltipRef.current) {
          tooltipRef.current.style.display = 'none'
        }
      }, 4000)
    }

    return () => {
      clearTimeout(timerHide)
      clearTimeout(timerShow)
    }
  }, [props?.fields?.Tooltip?.value])

  return (
    <div id={props?.rendering?.uid} className="lan-selector-wrapper">
      <div className="tooltip__wrapper">
        <div
          ref={tooltipRef}
          style={{ display: 'none' }}
          className="tooltiplang left align-center"
          role="tooltiplang"
          aria-hidden="true"
          data-is-active="false"
          data-is-focus="false"
        >
          {props?.fields?.Tooltip?.value}
        </div>
        <div ref={langRef} className="langs">
          {langs}
        </div>
      </div>
    </div>
  )
}
export default withRouter(LanguageSelector)
